// extracted by mini-css-extract-plugin
export var background = "_5y-0";
export var container = "_5y-1";
export var contentItem = "_5y-7";
export var extendedWarranty = "_5y-5";
export var link = "_5y-d";
export var modal = "_5y-b";
export var modalCloseButton = "_5y-9";
export var modalContent = "_5y-3";
export var modalContentMain = "_5y-6";
export var modalImageLogo = "_5y-8";
export var modalLogo = "_5y-a";
export var modalSideImage = "_5y-4";
export var preview = "_5y-c";
export var redoModal = "_5y-2";